import { render, staticRenderFns } from "./OutingSetting.vue?vue&type=template&id=56eab9db&scoped=true&lang=pug"
import script from "./OutingSetting.vue?vue&type=script&lang=ts"
export * from "./OutingSetting.vue?vue&type=script&lang=ts"
import style0 from "./OutingSetting.vue?vue&type=style&index=0&id=56eab9db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eab9db",
  null
  
)

export default component.exports